import {
  CCT_PATIENTS_DATA_REQUEST,
  CCT_PATIENTS_DATA_SUCCESS,
  CCT_PATIENTS_DATA_FAILURE,
  CCT_PATIENTST_FILTER_DROPDOWN_VALUE_SUBMIT,
  CCT_PATIENTST_CLEAR_PAGELIMIT,
  CCT_PATIENT_Provider_Id_UPDATE,
  CCT_PATIENT_Practice_Id_UPDATE,
  CCT_PATIENT_SELECTED_VALUE_ON_SUBMIT_CLEAR,
  CCT_DEFAULT_FILTER_CLEAR,
} from './types';

const initialState = {
  patients: {
    isFetching: false,
    data: [],
    error: {},
    dataLastUpdated: new Date(),
  },
  filterDropdownlist: {
    isFetching: false,
    data: [
      {
        id: 1,
        label: 'Patient',
      },
    ],
    error: {},
  },
  selectedvalueOnSubmit: {},
  pageLimit: null,
  kardiaRxCCTAutoCompleteSearch: {},
  patientPracticeAutoCompleteSearch: [],
  patientProviderAutoCompleteSearch: [],
  practiceId: null,
  providerId: null,
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [CCT_PATIENTS_DATA_REQUEST]: (state, action) => ({
    ...state,
    patients: {
      isFetching: true,
      data: [],
      error: {},
      dataLastUpdated: new Date(),
    },
  }),
  [CCT_PATIENTS_DATA_SUCCESS]: (state, action) => ({
    ...state,
    patients: {
      isFetching: false,
      data: action.payload,
      error: {},
      dataLastUpdated: new Date(),
    },
    kardiaRxCCTAutoCompleteSearch: action.payload[0].participants.map(item => {
      return {
        customParticipantID: item.mrn,
        firstName: item.patientFirstName,
        lastName: item.patientLastName,
        id: item.participantId,
      };
    }),
    patientPracticeAutoCompleteSearch: action.payload[0].participants.map(
      item => {
        return {
          teamName: item.orderingProviderTeamName
            ? item.orderingProviderTeamName
            : '',
          team_id: item.teamID ? item.teamID : '',
        };
      },
    ),
    patientProviderAutoCompleteSearch: action.payload[0].participants.map(
      item => {
        return {
          name: `${item.orderingProviderFirstName} ${item.orderingProviderLastName}`,
          member_id: item.orderingProviderID,
        };
      },
    ),
  }),
  [CCT_PATIENTS_DATA_FAILURE]: (state, action) => ({
    ...state,
    patients: {
      isFetching: false,
      data: [],
      error: 'failed',
      dataLastUpdated: new Date(),
    },
  }),
  [CCT_PATIENTST_FILTER_DROPDOWN_VALUE_SUBMIT]: (state, action) => ({
    ...state,
    selectedvalueOnSubmit: action.payload.values,
    pageLimit: action.payload.pageLimit,
  }),
  [CCT_PATIENTST_CLEAR_PAGELIMIT]: (state, action) => ({
    ...state,
    pageLimit: null,
  }),
  [CCT_PATIENT_Practice_Id_UPDATE]: (state, action) => ({
    ...state,
    practiceId: action.payload,
  }),
  [CCT_PATIENT_Provider_Id_UPDATE]: (state, action) => ({
    ...state,
    providerId: action.payload,
  }),
  [CCT_PATIENT_SELECTED_VALUE_ON_SUBMIT_CLEAR]: (state, action) => ({
    ...state,
    selectedvalueOnSubmit: {},
  }),
  [CCT_DEFAULT_FILTER_CLEAR]: (state, action) => ({
    ...state,
    selectedvalueOnSubmit: {},
    practiceId: null,
    providerId: null,
  }),

  // [CLEAR_STATE]: (state, action) => ({ ...initialState }),
};

//
// Reducer
// ------------------------------------
export const KardiaRxCCTPatient = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};



// WEBPACK FOOTER //
// ./src/views/state/KardiaRxCCTPatient/KardiaRxCCTPatientsReducers.js